import type { LangInfo } from "@kiwicom/nitro/lib/records/LangInfo"
import type { Brand } from "@kiwicom/nitro/lib/records/Brand"

const BASE_FONT_STACK =
  "-apple-system, '.SFNSText-Regular', 'San Francisco', 'Segoe UI', 'Helvetica Neue', 'Lucida Grande', sans-serif"

export const DEFAULT_FONT_FAMILY_CSS = `'Circular Pro', ${BASE_FONT_STACK}`

// This piece of logic is duplicated in @kiwicom/nitro/lib/records/Theme, but it is only available
// in later Nitro versions. We could clean this up once we upgrade.
//
const shouldLoadCircularProFont = (brandDomain: Brand["domain"]) =>
  brandDomain === "kiwi.com" || brandDomain.endsWith(".kiwi.com")

const getFontFamilyCssFromLanguageAndBrand = ({
  language,
  brandDomain,
}: {
  language: LangInfo
  brandDomain: Brand["domain"]
}): string =>
  language.specialFont
    ? `'${language.specialFont}', ${
        shouldLoadCircularProFont(brandDomain) ? DEFAULT_FONT_FAMILY_CSS : BASE_FONT_STACK
      }`
    : `${shouldLoadCircularProFont(brandDomain) ? DEFAULT_FONT_FAMILY_CSS : BASE_FONT_STACK}`

export default getFontFamilyCssFromLanguageAndBrand
